import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/code-tenderloin.github.io/code-tenderloin.github.io/src/components/layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const SEO = makeShortcode("SEO");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <SEO title="Home" keywords={["gatsby", "application", "react"]} mdxType="SEO" />
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/black-health-matters"
        }}>{`Black Health Matters`}</a></li>
    </ul>
    <h1>{`OFA`}</h1>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/OFA/2020-Fall"
        }}>{`Fall 2020`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/OFA/2020-Summer"
        }}>{`Summer 2020`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/OFA/2019-Summer"
        }}>{`Summer 2019`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      